import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import logoUser from '../../images/vixlogo.png';
import logoGuest from '../../images/vixlogo.png';
import menuArrow from '../../images/menu-downarrow.webp'
import { CurrentUserContext } from '../../context/CurrentUserContext';
import '../Navigation/Navigation.css';
import Logout from '../../images/Logout-icon.png'
import LangIcon from '../../images/lang-icon.png'
import { useLanguage } from "../../context/LanguageContext";
import { useTranslation } from "../../utils/hooks/translateHook";



const LANGUAGES = [
  { code: "en", label: "English"},
  { code: "es", label: "Español"},
  { code: "fr", label: "Français"},
  { code: "tr", label: "Turkçe"},
  { code: "pt", label: "Português"},
];

function Navigation ({
  onDesktopClick ,
  onMobileClick,
  onMobileMenu,
  onSignOut,
  isLoggedIn,
}) {
  const { language, setLanguage } = useLanguage();
  const [showLangMenu, setShowLangMenu]  = useState(false);
  const [showSignout, setShowSignout] = useState(false);
  const t = useTranslation();
  const {currentUser} = React.useContext(CurrentUserContext)
  const userRole = currentUser?.role || "guest";
  const isUser = isLoggedIn; 

  const location = useLocation();
  const isAdmin = userRole === 'admin' && location.pathname.startsWith("/admin");

  const langRef = useRef(null);

  const navClass = isUser ? "navigation-home" : "navigation";
  const menuItemClass = isUser ? "navigation__menu-item" : "navigation__menu-item-guest";  //nonmembera ayri css
  const buttonClass = isUser ? "navigation__menu-item navigation_menu-signout-button" : "navigation__menu-item-guest navigation__menu-signIn-button"
  const logoImage = isUser ? logoUser : logoGuest;
  const navigate = useNavigate();

  const onLanguage = () => {
    setShowLangMenu((prev) => !prev);
    setShowSignout(false);
  }

  const handleSelect = (code) => {
    setLanguage(code);
    setShowLangMenu(false);
  }

  const toggleSignout = () => {
    setShowSignout(prev => !prev);
    setShowLangMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setShowLangMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);




  return (
    <>  {/*div className="navcomponent" */}
    { 
      isAdmin ? (
        <nav className={`${navClass}`}>
        <div>
          <img className="navigation__logo" src={logoImage} alt="VixAcademy Logo" onClick={() => navigate("/")} />
        </div>
        <ul className="navigation__menu"> 
          <li><NavLink className={menuItemClass} to="/admin/dashboard">Dashboard</NavLink></li>
          <li><NavLink className={menuItemClass} to="/admin/users">Manage Users</NavLink></li>
          <li><NavLink className={menuItemClass} to="/admin/content">Manage Content</NavLink></li>  
          <li><button className={buttonClass} onClick={onSignOut}>{currentUser?.name || 'Sign Out'}</button></li>
        </ul>
      </nav>
      ) // ManageUsers - users db ekrani / popup predeletion 
      : isUser ? (
        <nav className={`${navClass}`}>
          <div>
            <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo"  onClick={() => navigate("/content")}/>
          </div>
          <ul className="navigation__menu">
            <li className="navigation__menu-list dropdown videos"> 
              <NavLink className={`${menuItemClass}`} to="/videos/1-1-1-what-is-forex">
                {t('videoCourses') }<img className="dropdown-arrow"src={menuArrow} />
              </NavLink>
          {/*     <div className="nav-submenu">
                <NavLink className="nav-sublink" to="/notes">Notes</NavLink>
              </div> */}
            </li>
            <li className="navigation__menu-list dropdown ebooks"> 
              <NavLink className={`${menuItemClass}`} to="/docs/">
                {t('ebooks')} <img className="dropdown-arrow"src={menuArrow} />
              </NavLink>
            </li>
            <li className="navigation__menu-list">
              <NavLink className={`${menuItemClass}`} to="/notes">{t('notes')}</NavLink>
            </li>
            <li className="navigation__menu-list"> 
              <NavLink className={`${menuItemClass}`} to="/utils">{t('tools')} </NavLink>
            </li>
            <li className="navigation__menu-list"> 
              <NavLink className={`${menuItemClass}`} to="/utils/glossary">{t('glossary').toUpperCase()} </NavLink>
            </li>
            <li className="navigation__menu-list"> 
              <NavLink className={`${menuItemClass}`} to="/packages">{t('packages')} </NavLink>
            </li> 
          </ul>
          <ul className="navigation__menu">
 
            <button className="langButton"onClick={onLanguage} ><img src={LangIcon}  /></button>
            { showLangMenu && (
              <ul className="language-dropdown" ref={langRef}> 
                {LANGUAGES.map(lang => (
                  <li key={lang.code} className="language-dropmenu-item" onClick={() => handleSelect(lang.code)}>
                    {lang.label.toUpperCase()}
                  </li>   
                ))}
              </ul>
            )}

            <li className="navigation__menu-list dropdown">  
              <button className={`${buttonClass}`} onClick={toggleSignout}>{currentUser?.name.slice(0,1) || 'Sign Out'}</button>
              <div className="nav-submenu userinfo">
                <p><button className={`${buttonClass}`} >{currentUser?.name.slice(0,1)}</button>{currentUser?.name}</p>
                {/* <p><img src={Logout} onClick={onSignOut} style={{width:"15px", marginLeft:"5px", padding:"0 4px"}}/> Log Out</p> */}
                <p style={{display:"flex"}}>
                  <button onClick={onSignOut} className="userinfo-button"><img src={Logout} ></img></button><a onClick={onSignOut} className="userinfo">{t('logout')}</a>
                </p>
              </div>
            </li>
            <li>
              <button className="navigation__menu-item-mobile-button" onClick={onMobileMenu} />
            </li>
          </ul>
 
        </nav>
          ) : (
            <nav className="navigation"> 
            <div className=""> 
              <Link to="/">
                <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo"  />
              </Link>
            </div>
            <ul className="navigation__menu"> 
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/aboutus">{t('aboutUs')}</NavLink> 
              </li>
              <li className="navigation__menu-list">
                 
                  <button className={`${menuItemClass} + menuItem-button `} onClick={ () => {
                    console.log('clicked');
                    onDesktopClick();
                  }}>
                    {t('signIn')}
                  </button>
                 
                  <button className="navigation__menu-item-mobile-button" onClick={onMobileClick}>
                    {t('signIn')}
                  </button>
              </li>
            </ul>
            </nav>
          )
        } 
     </>
  )
}

export default Navigation;